import "./TemporaryWeeklySchedule.html";
import "./TemporaryWeeklySchedule.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import TemporaryWeeklyScheduleComponentController from "./TemporaryWeeklyScheduleComponentController";

export default class TemporaryWeeklyScheduleComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            groupTypeName: "@",
            schedule: "=",
            site: "=",
        };
        this.controller = TemporaryWeeklyScheduleComponentController;
        this.templateUrl = "/App/Components/Forms/TemporaryWeeklySchedule/TemporaryWeeklySchedule.html";
    }
}

module("mmManagePortal").component("irTemporaryWeeklySchedule", new TemporaryWeeklyScheduleComponent());
